import { render } from "./mgrCdSelectBox.vue?vue&type=template&id=d23082e6"
import script from "./mgrCdSelectBox.vue?vue&type=script&lang=js"
export * from "./mgrCdSelectBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__